module.exports = __webpack_public_path__ + "static/img/d_bg.359fb4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/d_bg.jpg
// module id = NQnI
// module chunks = 1